import React, { ChangeEvent, CSSProperties, useEffect, useRef, useState } from 'react'
import classes from './Service.module.css'
import './select-search.css'
import { IoIosArrowDown } from 'react-icons/io'
import http from './../Service/http'
import { useTranslation } from 'react-i18next'

const Search = ({ changeIdStud, s_fio = '', style }: { changeIdStud: (param: number) => void; s_fio?: string; style?: CSSProperties }) => {
	const [text, setText] = useState({
		text: '',
		search: false
	})
	const search = useRef<HTMLInputElement>(null)
	const [students, setStudents] = useState<any[]>([])
	const { t } = useTranslation()
	const hundleText = (e: ChangeEvent<HTMLInputElement>) => {
		setText({
			text: e.target.value,
			search: true
		})
		changeIdStud(0)
	}

	const getStuds = async (param: string) => {
		const res = await http.post<any[], any>('/regis/searchStudentList', { s_fio_document: param })
		setStudents(res.data.DocumentRegStudentList)
	}

	useEffect(() => {
		if (text.search) getStuds(text.text)
	}, [text])
	useEffect(() => {
		setText({
			text: s_fio,
			search: false
		})

		const app = document.querySelector('.LayoutPage')
		if (app) {
			app.addEventListener('click', (e: any) => {
				if (e.target) {
					const searchWrap = e.target.closest('#search_list')
					if (!searchWrap) {
						setStudents([])
					}
				}
			})
		}
	}, [])

	return (
		<>
			<div className={classes.title}>{t('st:student.search')}</div>
			<div style={style} className={classes.search} id='search_list'>
				<div style={{ position: 'relative', padding: '1px' }}>
					<input
						ref={search}
						type='text'
						value={text.text}
						onInput={hundleText}
						onClick={e => {
							e.stopPropagation()
						}}
						className={classes.search_inp}
						onFocus={() => {
							setText({
								text: '',
								search: true
							})
							changeIdStud(0)
						}}
					/>
					<IoIosArrowDown
						onClick={e => {
							setStudents([])
							setText({
								text: '',
								search: true
							})
							changeIdStud(0)
						}}
						style={{
							fontSize: '16px',
							color: 'blue',
							position: 'absolute',
							top: '50%',
							right: '10px',
							zIndex: '3',
							transform: 'translateY(-50%)',
							cursor: 'pointer'
						}}
					/>
				</div>
				{text.search ? (
					<div className={classes.titles}>
						<div className={classes.fio}>ФИО</div>
						<div className={classes.faculty}>Факультет</div>
						<div className={classes.group}>Группа</div>
					</div>
				) : (
					''
				)}
				<div className={classes.list}>
					{students.map((item, i) => {
						return (
							<div
								key={i}
								onClick={async e => {
									await setText({
										text: item.s_fio,
										search: false
									})
									changeIdStud(item.id_student)
									setStudents([])
								}}
								className={classes.list_item}
							>
								<div className={classes.fio}>{item.s_fio}</div>
								<div className={classes.faculty}>{item.faculty}</div>
								<div className={classes.group}>{item.p20}</div>
							</div>
						)
					})}
				</div>
			</div>
		</>
	)
}
export default Search
